export const discoveryPlayerDependencies = (player) => {
  const { model: playerModel, config: playerConfig } = player
  
  return {
    // TODO: is this the right name?
    playerVendor: 'DiscoveryPlayer',
    // TODO: implement properties for Discovery player
    playerVersion: window.TOP?.Player?.Version?.libVersion,
    getCDN: () => playerModel.playlistItem?.entry?.metadata?.cdnType,
    currentVideoPosition: () => playerModel.mediaTime,
    currentMediaState: () => playerModel.mediaState,
    getVideoDurationSec: () => playerModel.mediaDuration,
    getStreamHost: () => playerModel.config?.metadata?.cdnHost,
    getStreamUrl: () => playerModel.playlistItem?.entry?.files?.[0]?.url,
    getAutoplay: () => playerConfig.playback?.autoPlay,
    getStreamType: () => playerModel.contentIsLive ? 'Live' : 'VOD',
    getLiveStreamName: () => playerModel.playlistItem?.entry?.id,
  }
}
